import { Injectable } from "@angular/core";
import { Language } from '../../../../Autofacets-Core/src/app/utils/enums';
import { GenericResponse } from '../business-entities/generic-response';
import { LanguageValue } from '../business-entities/language-value.model';
import { SelectListItemViewModel } from "../business-entities/select-list-item-view-model";
import { TemplateModel } from '../business-entities/template-model';
import { TemplateDataService } from '../data-services/template-data.service';

@Injectable({
    providedIn: 'root'
})

export class TemplateBusinessService {    
    templateId;
    dealerId: string;
    isEdit : boolean = false;
    dealerList: Array<SelectListItemViewModel>;
    constructor(private templateDataService:TemplateDataService) {
    }

    async GetTemplateList(requestModel: any) {
        return this.templateDataService.getList(requestModel);
    }

    async GetTemplate(templateId: number){
        return this.templateDataService.getTemplate(templateId);
    }

    AddTemplate(template: TemplateModel): Promise<GenericResponse<any>>{
        return this.templateDataService.addTemplate(template);
    }
    
    UpdateTemplate(template: TemplateModel): Promise<GenericResponse<any>>{
        return this.templateDataService.updateTemplate(template);
    }

    async getLanguage():Promise<GenericResponse<Array<LanguageValue>>>{
        return this.templateDataService.getLanguage();
    }

    getFlag(language:string):string{
        let uri = "assets/images/countryflags/"
        switch(language){
            case Language.English:
                uri= uri + "english.png";
                break;
            case Language.Dutch:
                uri = uri + "dutch.png";
                break;
            case Language.Norwegian:
                uri = uri + "norway.png";
                break;
            default:
                uri = uri + "english.png";
        }
        return uri;
    }


}